import type { UsagePolicy } from '@/common/types'

const TERMS_DISPLAY_ORDER = [
    'six-terms',
    'adviser-terms',
    'frankieone-terms',
    'finclear-terms',
    'monoova-terms',
    'cashhub-terms',
] as const

interface LegacyTermsAndConditionsContentProps {
    policies: UsagePolicy[]
}

/** Original (pre-uplift) content: one undifferentiated block of raw disclaimer HTML per policy, no checkboxes. */
export function LegacyTermsAndConditionsContent({ policies }: LegacyTermsAndConditionsContentProps) {
    return (
        <>
            {TERMS_DISPLAY_ORDER.map((slug) => {
                const policy = policies.find((p) => p.slug === slug)
                if (!policy) return null
                return (
                    <span
                        key={policy.slug}
                        className="disclaimer-html"
                        dangerouslySetInnerHTML={{
                            __html: policy.disclaimer.replace('Privacy Policy', 'Privacy&nbsp;Policy'),
                        }}
                    />
                )
            })}
        </>
    )
}
